// extracted by mini-css-extract-plugin
export default {"header":"classes@desktop_header__f+uNP"};